/**
 * 全站分享挂载点。页面按钮和游戏脚本都通过 window.ShareKit 打开同一弹窗。
 */
import { trackShare } from '../../analytics/track.ts'
import { mountShareKit } from '../../share-kit/mount.ts'
import { challengeMessage } from './challenge.ts'
import { miyucaiSite, miyucaiSitePayload } from './site.ts'
import type { ShareTrackEvent } from '../../share-kit/types.ts'

function track(event: ShareTrackEvent) {
  trackShare(event)
}

mountShareKit({
  site: miyucaiSite,
  sitePayload: miyucaiSitePayload,
  resolveChallenge: (location) => challengeMessage(location.pathname, new URLSearchParams(location.search)),
  onTrack: track,
})
